import { getRouteUrl as getUrl } from '@nackle/service-urls';

let baseUrl = window.location.hostname;
if ( baseUrl === 'localhost' ) {
    baseUrl = 'qa.studios.recognition-now.io';
}

export const IS_UMBRELLA = false;

export const ID_URL = getUrl( 'ID_PROVIDER' );
export const KAME_API_URL = getUrl( 'KAME_API' );
export const PISTON_URL = getUrl( 'PISTON_SERVICE' );
export const GAMIFICATION_URL = getUrl( 'GAMIFICATION_SERVICE' );
export const NISE_URL = getUrl( 'NISE' );
export const CYPHER_URL = getUrl( 'CYPHER' );

export const BADGE_HATCH_URL =  buildUrl( 'https://(env.)badge-hatch.biw.cloud/remoteEntry.js' );
export const TRANSLATIONS_EDITOR_HATCH_URL = buildUrl( 'https://(env.)translations-editor-hatch.biw.cloud/remoteEntry.js' );
export const ROSTER_GROUPS_HATCH_URL =  buildUrl( 'https://(env.)roster-groups.biw.cloud/remoteEntry.js' );
export const INCENTIVES_STUDIO_URL =  buildUrl( 'https://(env.)incentives-studio.biw.cloud' );

// Get environment from URL in address bar.
function getEnvironment() {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }
    
    return window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
}

function buildUrl( url ) {
    const env = getEnvironment();
    return url.replace( '(env.)', env ? env + '.' : '' );
}
